import { SavingsPlanCoverageDataWithId } from "@/components/pages/commtiments/common/utils/types";
import { CommitmentsDetailsRequestData } from "@/store/commitments/utils/types/types";
import { SavingsPlanCoverageGrouping } from "@/services/cloudchipr.api";

export const getCommitmentDetailsRequestDataFromSavingsPlanCoverage = (
  data: SavingsPlanCoverageDataWithId,
  grouping: SavingsPlanCoverageGrouping,
): CommitmentsDetailsRequestData => {
  const requestData: CommitmentsDetailsRequestData = {
    targetType: grouping,
    targetId: data?.id,
  };

  if (grouping === "commitment") {
    requestData.targetId = data?.savings_plan?.provider_id;
    requestData.commitmentId = data?.savings_plan?.id;
  }

  if (grouping === "account") {
    requestData.accountId = data?.account?.id;
    requestData.accountName = data?.account?.name ?? undefined;
    requestData.accountProviderId = data?.account?.provider_account_id;
  }

  if (grouping === "resource_type") {
    requestData.resourceType = data?.resource_type?.resource_type;
    requestData.region = data?.resource_type?.region ?? undefined;
    requestData.instanceFamily =
      data?.resource_type?.instance_family ?? undefined;
  }

  return requestData;
};
